/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Open newsletter popup on click a[href="#open-newsletter-popup"] 
  document.querySelectorAll('a[href="#open-newsletter-popup"]').forEach(function(link) {

    link.addEventListener('click', function(e) {
      e.preventDefault();

      var popup = document.querySelector('[data-large-promo]');
      if (!popup) return;

      // Find dialog inside popup
      var dialog = popup.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
        dialog.removeAttribute("inert");
        dialog.focus();
        document.dispatchEvent(new CustomEvent("theme:scroll:lock",{bubbles:!0}))
      }
    });

  });



  // Header search dynamic placeholder
  document.querySelectorAll('input[data-predictive-search-input]').forEach(function(searchInput) {
    if (searchInput) {
      const placeholders = JSON.parse(searchInput.dataset.placeholders);
      let index = 0;

      function changePlaceholder() {
        index = (index + 1) % placeholders.length;
        searchInput.placeholder = placeholders[index];
      }

      setInterval(changePlaceholder, 15000); // 15000ms = 15 seconds
    }
  });

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
